import styled from 'styled-components';
import { TableHead } from '@mui/material';

export const StyledTableCell = styled.span<{ maxLines?: number }>`
  ${({ maxLines }) => `
    ${maxLines && `
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${maxLines};
      -webkit-box-orient: vertical;
      word-break: break-word;
    `}
  `}
`;

export const StyledTableHeader = styled(TableHead) <{ colorheader?: string }>`
  ${({ theme, colorheader }) => `
    .MuiTableCell-head {
      ${colorheader === "true" && `
        background-color: ${theme.uptimeColors.mainTheme.primary} !important;
        color: ${theme.uptimeColors.grayScales.white} !important;
        font-weight: 600;
      `};
    }
  `}
`;